import { Typography } from 'antd';
import './HighlightComponent.scss';

const { Title } = Typography;

interface HighlightComponentProps {
  title: string;
  value: string;
}

const HighlightComponent = ({ title, value }: HighlightComponentProps) => {
  return (
    <div className="HighlightComponent">
      <Title level={4} className={'HighlightComponent__title'}>
        {title}
      </Title>
      <div className={'HighlightComponent__values'}>
        <Title level={3} className={'HighlightComponent__value'}>
          {value}
        </Title>
      </div>
    </div>
  );
};

export default HighlightComponent;
